export function timeAgo(unixSeconds: number): string {
  const diff = Date.now() / 1000 - unixSeconds;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export function fmtTime(unixSeconds: number): string {
  return `${new Date(unixSeconds * 1000).toISOString().replace('T', ' ').slice(0, 16)}Z`;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/**
 * Time at the *event's* location, approximated from longitude (≈15° per
 * hour — solar/nautical time, not political DST). Honest enough to answer
 * "what time was it where this happened?" without a timezone database.
 * e.g. "14:05 May 16 (UTC+9, local)".
 */
export function localTime(unixSeconds: number, lng: number): string {
  const offsetH = Math.max(-12, Math.min(14, Math.round(lng / 15)));
  const d = new Date((unixSeconds + offsetH * 3600) * 1000);
  const hh = String(d.getUTCHours()).padStart(2, '0');
  const mm = String(d.getUTCMinutes()).padStart(2, '0');
  const sign = offsetH >= 0 ? '+' : '−';
  return `${hh}:${mm} ${MONTHS[d.getUTCMonth()]} ${d.getUTCDate()} (UTC${sign}${Math.abs(offsetH)}, local)`;
}

const FLAG_OFFSET = 0x1f1e6;
export function countryFlag(code?: string | null): string {
  if (!code || code.length !== 2) return '🌐';
  return String.fromCodePoint(
    ...[...code.toUpperCase()].map((c) => FLAG_OFFSET + c.charCodeAt(0) - 65),
  );
}

export function classNames(...xs: Array<string | false | null | undefined>): string {
  return xs.filter(Boolean).join(' ');
}

/** "First Last" → "Last, F." (privacy-posture display). Falls back to the
 *  raw value when there's no parseable surname. */
export function lastFirst(name?: string | null): string {
  if (!name) return 'Unknown';
  const parts = name.trim().split(/\s+/);
  if (parts.length < 2) return name;
  const last = parts[parts.length - 1]!;
  const first = parts[0]!;
  return `${last}, ${first[0]}.`;
}

/** Deterministic synthetic "days until departure" for the demo traveler
 *  framing (no schema field). Stable per employee id, 3–120 days. */
export function daysUntilDeparture(employeeId: number): number {
  const x = Math.sin(employeeId * 73.13) * 9973;
  return 3 + Math.floor((x - Math.floor(x)) * 118);
}
